import SEO from "../components/SEO";

const PolitiqueConfidentialite = () => {
    return (
        <>
            <SEO
                title="Politique de confidentialité — Fiduciaire Bleich"
                description="Politique de confidentialité de la Fiduciaire Bleich Sàrl, conforme à la LPD suisse."
                canonical="https://fiduciaire-bleich.ch/politique-confidentialite"
            />
            <article
                data-testid="privacy-page"
                className="bg-white py-20 lg:py-28"
            >
                <div className="container-prose max-w-3xl">
                    <div className="inline-flex items-center gap-2 mb-6 text-xs uppercase tracking-[0.25em] text-[#5C6B70]">
                        <span className="w-8 h-px bg-[#1C9CAC]" />
                        Protection des données
                    </div>
                    <h1 className="font-serif text-5xl sm:text-6xl text-[#2C3E45] leading-tight tracking-tight mb-12">
                        Politique de <span className="italic">confidentialité.</span>
                    </h1>

                    <div className="space-y-10 text-[#5C6B70] leading-[1.75]">
                        <p>
                            La présente politique de confidentialité décrit la manière dont la
                            Fiduciaire Bleich Sàrl collecte, utilise et protège les données
                            personnelles des visiteurs de son site internet, conformément à la
                            Loi fédérale suisse sur la protection des données (LPD), en
                            vigueur depuis le 1<sup>er</sup> septembre 2023.
                        </p>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                1. Responsable du traitement
                            </h2>
                            <p>
                                Fiduciaire Bleich Sàrl
                                <br />
                                Rue de Rive 8, 1204 Genève, Suisse
                                <br />
                                Email : info@fiduciaire-bleich.ch
                                <br />
                                Téléphone : +41 22 319 34 40
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                2. Données collectées
                            </h2>
                            <p>
                                Nous collectons uniquement les données que vous nous fournissez
                                volontairement via le formulaire de contact :
                            </p>
                            <ul className="list-disc pl-6 mt-3 space-y-1">
                                <li>Nom et prénom</li>
                                <li>Adresse email</li>
                                <li>Numéro de téléphone (facultatif)</li>
                                <li>Sujet et contenu de votre message</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                3. Finalités du traitement
                            </h2>
                            <p>
                                Vos données sont utilisées exclusivement pour répondre à votre
                                demande, vous recontacter et, le cas échéant, vous proposer un
                                rendez-vous. Elles ne sont en aucun cas utilisées à des fins
                                commerciales ni transmises à des tiers à cette fin.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                4. Base légale
                            </h2>
                            <p>
                                Le traitement repose sur votre consentement explicite, donné
                                lors de la soumission du formulaire de contact (LPD art. 6).
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                5. Destinataires
                            </h2>
                            <p>
                                Les messages envoyés via le formulaire sont transmis à la
                                Fiduciaire Bleich Sàrl par l'intermédiaire de notre prestataire
                                technique d'envoi de formulaire (Formspree, société établie
                                aux États-Unis). Ce prestataire agit en qualité de
                                sous-traitant et est tenu d'assurer un niveau de protection
                                adéquat des données.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                6. Durée de conservation
                            </h2>
                            <p>
                                Vos données sont conservées le temps nécessaire au traitement
                                de votre demande, puis archivées ou supprimées selon nos
                                obligations légales et professionnelles (notamment les délais
                                de conservation imposés par la législation suisse en matière
                                comptable et fiscale).
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                7. Vos droits
                            </h2>
                            <p>
                                Conformément à la LPD, vous disposez à tout moment d'un droit
                                d'accès, de rectification, d'effacement et d'opposition
                                concernant vos données personnelles. Pour exercer ces droits,
                                contactez-nous à l'adresse{" "}
                                <a
                                    href="mailto:info@fiduciaire-bleich.ch"
                                    className="text-[#1C9CAC] hover:text-[#16818F] transition-colors"
                                >
                                    info@fiduciaire-bleich.ch
                                </a>
                                . Vous disposez également du droit de déposer une plainte
                                auprès du Préposé fédéral à la protection des données et à
                                la transparence (PFPDT) —{" "}
                                <a
                                    href="https://www.edoeb.admin.ch"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-[#1C9CAC] hover:text-[#16818F] transition-colors"
                                >
                                    www.edoeb.admin.ch
                                </a>
                                .
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                8. Sécurité
                            </h2>
                            <p>
                                Nous mettons en œuvre des mesures techniques et
                                organisationnelles raisonnables pour protéger vos données
                                contre tout accès non autorisé, perte ou divulgation.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                9. Cookies
                            </h2>
                            <p>
                                Ce site n'utilise pas de cookies à des fins publicitaires ou de
                                profilage. Seuls des cookies techniques strictement nécessaires
                                au bon fonctionnement du site peuvent être déposés.
                            </p>
                        </section>

                        <section>
                            <h2 className="font-serif text-2xl text-[#2C3E45] mb-3">
                                10. Modifications
                            </h2>
                            <p>
                                La présente politique de confidentialité peut être mise à jour
                                pour refléter les évolutions légales ou techniques. Toute
                                modification sera publiée sur cette page.
                            </p>
                        </section>

                        <p className="text-sm text-[#5C6B70] italic pt-6 border-t border-[#E5E7EB]">
                            Dernière mise à jour : mai 2026.
                        </p>
                    </div>
                </div>
            </article>
        </>
    );
};

export default PolitiqueConfidentialite;
